import { useEffect, useState } from 'react';

type CountdownProps = {
  targetDate: Date;
};

function pad(n: number): string {
  return n.toString().padStart(2, '0');
}

export function Countdown({ targetDate }: CountdownProps) {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (targetDate.getTime() <= Date.now()) {
      return undefined;
    }

    const id = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(id);
  }, [targetDate]);

  const diff = Math.max(0, targetDate.getTime() - now);

  if (diff === 0) {
    return null;
  }

  const days = Math.floor(diff / (24 * 60 * 60 * 1000));
  const hours = Math.floor((diff % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000));
  const minutes = Math.floor((diff % (60 * 60 * 1000)) / (60 * 1000));
  const seconds = Math.floor((diff % (60 * 1000)) / 1000);

  return (
    <div className="countdown" role="timer" aria-live="polite">
      <div className="countdown__unit">
        <span className="countdown__value">{days}</span>
        <span className="countdown__label">jours</span>
      </div>
      <div className="countdown__unit">
        <span className="countdown__value">{pad(hours)}</span>
        <span className="countdown__label">heures</span>
      </div>
      <div className="countdown__unit">
        <span className="countdown__value">{pad(minutes)}</span>
        <span className="countdown__label">minutes</span>
      </div>
      <div className="countdown__unit">
        <span className="countdown__value">{pad(seconds)}</span>
        <span className="countdown__label">secondes</span>
      </div>
    </div>
  );
}
